// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__U4SiY","IconContainer":"styles_IconContainer__VMihD","icon":"styles_icon__AMJ06","tabName":"styles_tabName__QFL1G","active":"styles_active__GDvqw"};